// extracted by mini-css-extract-plugin
export default {"Wrapper":"ContractsMoreFilters_Wrapper__Ndc7l","Table":"ContractsMoreFilters_Table__rB710","Section":"ContractsMoreFilters_Section__LjSSA"};